import { Mapper } from '../../../../../core/base';
import { PlanJobDetails } from 'planning-portal-library/src/lib/core/domain/models/plan-job-details';
import { PlanJobDetailWebEntity } from './plan-job-detail-web-entity';
import { DateTime } from 'luxon';

export class PlanJobDetailWebRepositoryMapper extends Mapper<
  PlanJobDetailWebEntity,
  PlanJobDetails
> {
  mapFrom(param: PlanJobDetailWebEntity): PlanJobDetails {
    return {
      planId: param.planId,
      planName: param.planName,
      description: param.description,
      distributionLaneId: param.distributionLaneId,
      distributionLaneName: param.distributionLaneName,
      // jobs: param.jobs?.map((item) => ({
      //   jobId: item.jobId,
      //   jobName: item.jobName,
      //   jobNumber: item.jobNumber,
      //   jobColor: item.jobColor,
      //   endAddress: item.endAddress,
      //   endLatitude: item.endLatitude,
      //   endLongitude: item.endLongitude,
      //   endTerminalName: item.endTerminalName,
      //   startTerminalName: item.startTerminalName,
      //   startAddress: item.startAddress,
      //   startLatitude: item.startLatitude,
      //   startLongitude: item.startLongitude,
      //   locationCount : item.locationCount,
      //   locations: item.locations?.map((location) => ({
      //     id: location.id,
      //     address: location.address,
      //     latitude: location.latitude,
      //     longitude: location.longitude,
      //     locationName: location.locationName,
      //     stopNumber: location.stopNumber,
      //     stopTime: location.stopTime!,
      //     jobId: item.jobId,
      //     arrivalTime: location.arrivalTime
      //       ? DateTime.fromISO(location.arrivalTime.toString())
      //       : undefined,
      //     departureTime: location.departureTime
      //       ? DateTime.fromISO(location.departureTime.toString())
      //       : undefined,
      //     createdAt: location.createdAt,
      //     city: location.city,
      //     country: location.country,
      //     locationId: location.locationId,
      //     deliveryCapacityType3: location.deliveryCapacityType3,
      //     deliveryCapacityType2: location.deliveryCapacityType2,
      //     deliveryCapacityType1: location.deliveryCapacityType1,
      //     isScheduled: location.isScheduled,
      //     pickupCapacityType1: location.pickupCapacityType1,
      //     pickupCapacityType2: location.pickupCapacityType2,
      //     pickupCapacityType3: location.pickupCapacityType3,
      //     servicesCount: location.servicesCount,
      //     serviceTime: location.serviceTime,
      //     postalCode: location.postalCode,
      //     precedence: location.precedence,
      //     sequenceNumber: location.sequenceNumber,
      //     template: location.template,
      //     priority: location.priority,
      //     jobNumber: location.jobNumber,
      //     planName: location.planName,
      //     planId: location.planId,
      //     qualifications: location.qualifications,
      //     distributionLaneId: location.distributionLaneId,
      //     customData: location.customData,
      //     isEndTerminal: location.isEndTerminal,
      //     isStartTerminal: location.isStartTerminal,
      //     segment: location.segment,
      //     productName: location.productName,
      //     productId: location.productId,
      //     tenantLocationId: location.tenantLocationId,
      //     services: location.services?.map((service) => ({
      //       id: service.id,
      //       objectType: service.objectType,
      //       action: service.action,
      //       size: service.size,
      //       weight: service.weight,
      //       customData: service.customData,
      //     })),
      //   })),
      //   startTime: item.startTime!,
      //   endTime: item.endTime!,
      // })),
      isScheduled: param.isScheduled,
      resources: param.resources?.map((resource) => ({
        sourceType: resource.sourceType,
        jobResourceDetails: resource.jobResourceDetails?.map((detail) => ({
          vehicleType: detail.vehicleType,
          noOfResource: detail.noOfResource,
          capacityType1 : detail.capacityType1,
          capacityType2 : detail.capacityType2,
          capacityType3 : detail.capacityType3,
        })),

      })),
      planRules:param.planRules,
    };
  }

  mapTo(param: PlanJobDetails): PlanJobDetailWebEntity {
    return {
      planId: param.planId,
      planName: param.planName,
      description: param.description,
      distributionLaneId: param.distributionLaneId,
      distributionLaneName: param.distributionLaneName,
      // jobs: param.jobs?.map((item) => ({
      //   jobId: item.jobId,
      //   jobName: item.jobName,
      //   jobNumber: item.jobNumber,
      //   jobColor: item.jobColor,
      //   endAddress: item.endAddress,
      //   endLatitude: item.endLatitude,
      //   endLongitude: item.endLongitude,
      //   startAddress: item.startAddress,
      //   startLatitude: item.startLatitude,
      //   startLongitude: item.startLongitude,
      //   locations: item.locations?.map((location) => ({
      //     id: location.id,
      //     address: location.address,
      //     latitude: location.latitude,
      //     longitude: location.longitude,
      //     locationName: location.locationName,
      //     stopNumber: location.stopNumber,
      //     stopTime: location.stopTime!,
      //     jobId: item.jobId,
      //     arrivalTime: location.arrivalTime
      //       ? DateTime.fromISO(location.arrivalTime.toString())
      //       : undefined,
      //     departureTime: location.departureTime
      //       ? DateTime.fromISO(location.departureTime.toString())
      //       : undefined,
      //     createdAt: location.createdAt,
      //     city: location.city,
      //     country: location.country,
      //     locationId: location.locationId,
      //     deliveryCapacityType3: location.deliveryCapacityType3,
      //     deliveryCapacityType2: location.deliveryCapacityType2,
      //     deliveryCapacityType1: location.deliveryCapacityType1,
      //     isScheduled: location.isScheduled,
      //     pickupCapacityType1: location.pickupCapacityType1,
      //     pickupCapacityType2: location.pickupCapacityType2,
      //     pickupCapacityType3: location.pickupCapacityType3,
      //     servicesCount: location.servicesCount,
      //     serviceTime: location.serviceTime,
      //     postalCode: location.postalCode,
      //     precedence: location.precedence,
      //     sequenceNumber: location.sequenceNumber,
      //     template: location.template,
      //     priority: location.priority,
      //     jobNumber: location.jobNumber,
      //     planName: location.planName,
      //     planId: location.planId,
      //     qualifications: location.qualifications,
      //     distributionLaneId: location.distributionLaneId,
      //     customData: location.customData,
      //     isEndTerminal: location.isEndTerminal,
      //     isStartTerminal: location.isStartTerminal,
      //     services: location.services?.map((service) => ({
      //       id: service.id,
      //       objectType: service.objectType,
      //       action: service.action,
      //       size: service.size,
      //       weight: service.weight,
      //       customData: service.customData,
      //     })),
      //   })),
      //   startTime: item.startTime!,
      //   endTime: item.endTime!,
      // })),
      isScheduled: param.isScheduled,
      planRules:param.planRules,
    };
  }
}
